import {Link} from 'react-router-dom';
import styled, {css} from 'styled-components';

export const FullScreen = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding: 1.25rem;
    background: rgba(0,0,0,0.5);
    z-index: 600;
`;

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column; 
    font-size: calc(100vw*(20/375));
    line-height: 1.2;
    letter-spacing: -0.48px;
    text-align: center;
    width:  calc(100vw*(346/375));
`;

export const ButtonListarea = styled.ul`
    display: flex;
    flex-direction: column; 
    font-size: calc(100vw*(20/375));
    line-height: 1.2;
    letter-spacing: -0.48px;
    text-align: center;
    width:  calc(100vw*(346/375));
    border-radius:  calc(100vw*(10/375));
    background-color: #ffffff;
`

export const ButtonList = styled.li`
    border-bottom: 1px solid #d5d5d5;
    width:  calc(100vw*(346/375));
    height:  calc(100vw*(56/375));
    
    &:last-child {
        border: 0;
    }
`;

const buttonStyle = css`
    width: 100%;
    height: 100%;
    color: #4e4e4e;
    font-weight: 400;

`

export const CancelButtonarea = styled.div` 
    font-size: calc(100vw*(20/375));
    line-height: 1.2;
    letter-spacing: -0.48px;
    text-align: center;
    width:  calc(100vw*(346/375));
    height:  calc(100vw*(56/375));
    border-radius:  calc(100vw*(10/375));
    -webkit-backdrop-filter: blur( calc(100vw*(20/375)););
    backdrop-filter: blur( calc(100vw*(20/375)););
    background-color: #ffffff;
    margin-top:calc(100vw*(9/375));
`
export const CancelButton = styled.button`
    color: #008AFF;
    font-weight: 400;
    width: 100%;
    height: 100%;
`;

export const ButtonStyle = styled.button`
    ${buttonStyle}
`

export const LinkStyle = styled(Link)`
    display: flex;
    justify-content: center;
    align-items: center;
    ${buttonStyle}
`